module.exports = __webpack_public_path__ + "static/media/432773-1377673-1_500x500.bdccd087.jpg";